import { OptsGeneric, IGenList } from '@educraft/base';

export interface OptsList extends OptsGeneric {
  items: { key: string; value: string }[]; // Or direct items (optional, defaults to empty array)
}

export function getListItems(opts: OptsList): { key: string; value: string }[] {
  return opts.items ?? [];
}
